export function normalizeAccountNumber(accountNumber: string) {
  return accountNumber.replace(/[\s.]/g, '');
}
